<template>
  <div class="animated fadeIn gofixTab contractEquipmentTab assetManagement bgV2" v-bind:class="{'run-loading':loading}">
    <div class="boxShadow h-100 setBorderRadius">
        <div class="h-100">
            <b-row class="h-100">
                <b-col md="12" class="h-100">
                    <gofix-card title="Navision Cronjob Setting" fullContent >
                        <template slot="gofixCard:right_header">
                            <div class="d-flex justify-content-end align-items-center">
                                <gofix-button :disabled="!$checkRole($accessModule.navision_cronjob_setting, 'create')" label="Save" @click="autoSave" :loading="loadingSave"></gofix-button>
                            </div>
                        </template>
                        <div class="opening-hours-management">
                            <ul>
                                <li class="item" v-for="(item,index) in arrNavisionCronJob" :key="index">
                                <b-row align-v="center">
                                    <b-col md="1"><span class="item-title">{{item.type}}</span></b-col>
                                    <b-col md="1">
                                    <div class="status">
                                        <b-form-checkbox v-model="item.status" value="Open" unchecked-value="Close" switch>
                                        </b-form-checkbox>
                                    </div>
                                    </b-col>
                                    <b-col md="2" v-if="item.status == 'Open'">
                                        <gofix-form-input label="Minute" v-model="item.minute"></gofix-form-input>
                                    </b-col>
                                    <b-col md="2" v-if="item.status == 'Open'">
                                        <gofix-form-input label="Hour" v-model="item.hour"></gofix-form-input>
                                    </b-col>
                                    <b-col md="2" v-if="item.status == 'Open'">
                                        <gofix-form-input label="Day" v-model="item.day"></gofix-form-input>
                                    </b-col>
                                    <b-col md="2" v-if="item.status == 'Open'">
                                        <gofix-form-input label="Month" v-model="item.month"></gofix-form-input>
                                    </b-col>
                                    <b-col md="2" v-if="item.status == 'Open'">
                                        <gofix-form-input label="Week" v-model="item.week"></gofix-form-input>
                                    </b-col>
                                </b-row>
                                </li>
                            </ul>
                        </div>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'navision-cronjob-setting',
  data() {
    return {
      arrNavisionCronJob:[],
      tableItems: [
        {
            type:'PAP',
            status:'Open',
            minute:null,
            hour:null,
            day:null,
            month:null,
            week:null
        },
        {
            type:'PGL',
            status:'Open',
            minute:null,
            hour:null,
            day:null,
            month:null,
            week:null
        },
        {
            type:'REC',
            status:'Open',
            minute:null,
            hour:null,
            day:null,
            month:null,
            week:null
        },
        {
            type:'INV',
            status:'Open',
            minute:null,
            hour:null,
            day:null,
            month:null,
            week:null
        },
        {
            type:'OFF',
            status:'Open',
            minute:null,
            hour:null,
            day:null,
            month:null,
            week:null
        }      
      ],
      loading:false,
      loadingSave:false
    }
  },
  components: {
  },
  created() {
      this.loadNavisionCronjobList();
  },
  watch: {

  },
  computed: {},
  methods: {
    async autoSave(){
        let request = {
            data :this.arrNavisionCronJob
        };
        this.loadingSave = true;
        this.$store.dispatch("NavisionFileController/updateNavisionCronJob", request)
            .then(response => {
                this.loadingSave = false;
                this.$alertNotification("Update successfully!", "success");
            })
            .catch(err => {
                this.loadingSave = false;
                console.log(err);
            })
        
    },
    async loadNavisionCronjobList(){
        this.loading = true;
        this.arrNavisionCronJob = this.tableItems;
        let request = {
            limit : -1,
            page : 1,
            isCMS : 1,
            filter : null,
            sortColumn : 'created_at',
            sortDirection : 'asc'
        };
        await this.$store.dispatch("NavisionFileController/getNavisionCronjobList", request)
            .then(response => {
                this.loading = false;
                if(response.data.data.items.length > 0){
                    this.arrNavisionCronJob = response.data.data.items;
                }
            })
            .catch(err => {
                this.loading = false;
                console.log(err);
                //this.$alertNotification("Can not load items", "danger");
                //reject();
            })
    }
  },
}
</script>